'use strict';

const libPictView = require('pict-view');

/**
 * UserLoginOverview — the #/UserLoginOverview screen. A roster of the customer's users with login recency
 * (Active / Idle / Dormant / Never), a recency doughnut computed from exact server counts, and a search/filter.
 *
 * Thin shell over the shared ActivityObservability provider (renders into #AO-Logins-Body).
 */
class UserLoginOverview extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ActivityObservability; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._ensureStyles();
			tmpProvider.renderLogins();
			if (!tmpProvider.logins.Loading) { tmpProvider.loadLoginsAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = UserLoginOverview;
module.exports.default_configuration =
{
	ViewIdentifier: 'UserLoginOverview',
	// Reusable app-shell Dashboard Mode — render full browser width (see PlatformConfiguration-Router _applyDashboardMode).
	DashboardMode: true,
	DefaultRenderable: 'UserLoginOverviewWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: '',
	Templates:
	[
		{
			Hash: 'UserLoginOverview-Wrap',
			Template: /*html*/`
				<div class="ao-wrap">
					<div class="ao-head">
						<h1 class="ao-title">User Logins</h1>
						<p class="ao-subtitle">Every user and when they last signed in — with an at-a-glance breakdown of who is active, idle, dormant, or has never logged in.</p>
					</div>
					<div id="AO-Logins-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'UserLoginOverviewWrap',
			TemplateHash: 'UserLoginOverview-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
